
import { useDevMode } from '../../hooks/useDevMode'

const DevDashboard = () => {
  const { isDevMode, toggleDevMode } = useDevMode()

  return (
    <div style={{ padding: '20px' }}>
      <h1>Dev Dashboard</h1>
      <p>Developer Mode: {isDevMode ? 'Enabled' : 'Disabled'}</p>
      <button onClick={toggleDevMode}>
        {isDevMode ? 'Disable' : 'Enable'} Dev Mode
      </button>
      <div style={{ marginTop: '20px' }}>
        <h2>Dev Features</h2>
        <ul>
          <li>Feature 1: Debug logging enabled</li>
          <li>Feature 2: Test routes accessible</li>
          <li>Feature 3: Admin tools visible</li>
        </ul>
      </div>
    </div>
  )
}

export default DevDashboard